<template>
  <div>
      <full-page  ref="fullpageHome" :options="options" id="fullpage">

        <div id="section000"  class="section">
          <h2>LOADING...</h2>

        </div>

        <div id="section86" class="section">

          <b-container class="h-100">
                <b-row class="h-100 align-items-center justify-content-center">
              <b-col><h1>SEASON TWO TRAILER</h1>
               <iframe id="agVideo" src="" width='640px' height='360px' frameborder='0' ></iframe> 
               </b-col>
            </b-row>
          </b-container>

          <!-- <video id="myVideo" data-autoplay playsinline controls autoplay  loop>
					  <source src="/americangodsS2/static/vid/ags2_official_hero_trailer_bond.mp4" type="video/mp4">
					</video> -->

          <!-- <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" /> -->

        </div>

      </full-page>
  </div>
</template>

<script>

export default {
  name: 'Trailer',
  metaInfo: {
    title: 'Trailer' // set a title
  },
  data () {
    return {
      options: {
        licenseKey: '08F6AFDB-F75D4F5A-AE124C87-3D28719F',
        menu: '#menu',
        anchors: ['loading', 'trailer'],
        slidesNavigation: true,
        controlArrows: true,
        scrollOverflow: true,
        lazyLoading: false,
        onLeave: this.onLeave,
        afterLoad: this.afterLoad
      }
    }
  },
  methods: {
    afterLoad (origin, destination, direction) {
      if (destination.index === 0) {
        this.$refs.fullpageHome.api.moveSectionDown()
      }
    },
    onLeave (origin, destination, direction) {
      if (destination.index === 0) {
        document.getElementById('stzHeaderTitleArt').classList.add('titleArt-Hidden')
        document.getElementById('stzHeaderTitleArt').classList.remove('logo')
      }
      if (origin.index === 1 && destination === 'up') {
        document.getElementById('stzHeaderTitleArt').classList.add('titleArt-Hidden')
        document.getElementById('stzHeaderTitleArt').classList.remove('logo')
      }
      // Trailer
      var s = 'https://www.starz.com/videos/embed/bf1b1935-ed9a-42a1-853f-89fc1855b424?footer=false&cid=1082635'
      var iframe = document.getElementById('agVideo')
      if (destination.index === 1) {
        // Set the Video iframe Source
        iframe.src = s
      } else {
        iframe.src = ''
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import "../styles/Trailer.scss";
</style>



// WEBPACK FOOTER //
// src/components/Trailer.vue